import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { listMutations } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladOv: [],
		Stanoviste: [],
		VyrobekvozOzn: [],
	},
	filter: {
		VyrobekvozOzn: null as string | null,
		Typkod: null as string | null,
		TypkodText: null as string | null,
		KaroserieNr: null as string | null,
		Spz: null as string | null,
		IbsKod: null as string | null,
		PovNr: null as number | null,
		SkladoveOvPrp: null as boolean | null,
		KomisniOvPrp: null as boolean | null,
		MotorNr: null as string | null,
		SkladovOzn: null as string | null,
		Stanovst: null as string | null,
		OvprijemkaPfx: null as string | null,
		OvprijemkaNr: null as number | null,
		OvprijemkaDatOd: null as string | null,
		OvprijemkaDatDo: null as string | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[listMutations.SKLAD_OV_FILTER_TYPKOD](state, { data, mode }) {
			if (!data.isClear) {
				state.filter.VyrobekvozOzn = data.vyrobekvozozn;
			}
			state.filter.Typkod = data.typkod;
			state.filter.TypkodText = data.text;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
